
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import AnnoucementService from "@/services/Annoument.service";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import CoinService from "@/services/coins.service";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "../../models/porposal/porposalMembers.model";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Document from "../../models/document.model";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import BudgetExpenseService from "@/services/budgetExpense.service";
import AnnoucementAreasService from "@/services/AnnoumentArea.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import ResearchCenterService from "@/services/researchCenter.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import UserBasicInformationByEmailComponent from "@/components/user-basic-information/userBasicInformationInsideSearch.vue";
import DocumentComponentViewer from "@/components/document-component-view/documentComponentViewer.vue";
import UserService from "@/services/user.service";
import PorposalService from "@/services/porposal.service";
import { Utils } from "../../core/Utils";
import ProposalEvaluationComponent from "@/components/Proposal-Evaluations/proposal-evaluation-component.vue";
import { ProjectState } from "@/enums/projectState";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import BTableColumn from "@/models/base/BTableColumn.model";
import fileService from "@/services/file.service";
import { ProposalState } from "../../enums/ProposalState";
import ProposalUserReport from "../../models/porposal/porposalUserReport.model";
import ProposalDisbursement from "../../models/porposal/proposalDisbursement.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Axios from "axios";
import PorposalBudgetSubItemInstitutionDetail from "@/models/porposal/porposalBudgetSubItemInstitutionDetail.model";
import PorposalBudgetSubItem from "@/models/porposal/porposalBudgetSubItem.model";
import { YearPeriod } from "@/enums/YearPeriod";
import BudgetItem from "@/models/porposal/budgetItem.model";
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";
import BudgetExecution from "@/components/porposal-detail-component/budgetExecution.vue";
import BaseInputNumber from "@/components/base/baseInputNumber/baseInputNumber.vue";
import ProposalHistoricPercentDoneScheduleGantt from "../../models/porposal/proposalHistoricPercentDoneScheduleGantt.model";
import { PermissionValue } from "@/enums/PermissionValue";
import PermissionAccess from "@/models/security/permissionAccess.model";
import EspecificObjective from "@/models/porposal/especificObjective.model";
import AnalyticalMatrixEvaluation from "@/models/analyticalMatrixEvaluation.model";
import { ReportEvaluationState } from "@/enums/ReportEvaluationState";
import UserBasicInformationCni from "@/components/user-basic-information/userBasicInformationCni.vue";

@Component({
  components: {
    DatePickerComponent,
    documentcomponent: DocumentComponent,
    ResearchCenterBasicInformationComponent,
    UserBasicInformationComponent,
    DocumentComponentViewer,
    ProposalEvaluationComponent,
    UserBasicInformationByEmailComponent,
    GantCharttComponent,
    BudgetExecution,
    BaseInputNumber,
    UserBasicInformationCni,
  },
})
export default class PorposalDetail extends GenericEdit<Porposal> {
  @Prop() public pId!: number; // porposalId
  @Prop() public showAnswersTab!: boolean;
  @Prop() public isEvaluationView!: boolean;
  @Prop() public movimientos!: [];
  @Prop() public evaluators!: [];
  @Prop() public updateReports!: number;
  @Prop() public selectTabItem!: number;
  @Prop() public showReportActionButtons!: boolean;
  @Prop() public currentUserAnalyticalMatrixEvaluations!: Array<
    AnalyticalMatrixEvaluation
  >;
  @Prop() public currentReportEvaluationId!: number;

  updatedUserAnalyticalMatrixEvaluations: Array<
    AnalyticalMatrixEvaluation
  > = [];
  protected tableConfig: BTableConfig<Porposal> = new BTableConfig<Porposal>();
  protected disbursementsTableConfig: BTableConfig<
    ProposalDisbursement
  > = new BTableConfig<ProposalDisbursement>();
  defaultOpenedDetails: any = [];
  currentTab = 1;
  memberTypes: any = [];
  projectTypes: any = [];
  isComponentModalActive: boolean = false;
  areas: any = [];
  motivoDevolucion: string = null;
  fieldAreas: any = [];
  fieldAreasResearchLines: any = [];
  researchCenter: any = null;
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  CoinService = new CoinService();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  annoucementAreasService: AnnoucementAreasService = new AnnoucementAreasService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  userService: UserService = new UserService();
  proposalService: PorposalService = new PorposalService();
  researchCenters = [];
  counter: number;
  words: any;
  loading = false;
  dropFiles = [];
  Coins: [];
  annoucementId: number | null = null;
  years: Array<number> = [];
  budgetExpenses = [];
  budgetItemCurrent = new PorposalBudgetItem();
  showAddPartida = false;
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;
  inProgressState: ProjectState = ProjectState.InProgress;
  finished: ProjectState = ProjectState.Finished;
  files = [];
  selected = {};
  showWarning = false;
  displayComponent = true;
  oldEvaluators: any = null;
  estadoCreado: ProposalState = ProposalState.Creado;
  estadoDevueltoCI: ProposalState = ProposalState.DevueltoCI;
  estadoEnviadoAFC: ProposalState = ProposalState.EnviadoFC;
  tickManager: number = 5;
  ticks: Array<number> = [1];

  finishedState: ProjectState = ProjectState.Finished;
  inHoldState: ProjectState = ProjectState.InHold;
  activeTab: number = 0;
  activeTab2: number = 0;
  isLoading: boolean = false;
  principalInvestigatorName = "";
  budgetEditMode = false;
  currentMemberEffortToPrint: any = null;

  currentDirsbuserment: ProposalDisbursement = new ProposalDisbursement();
  requestDateFile: any = null;
  deliveryDateFile: any = null;
  showChangeStatus: boolean = false;
  isEditingActivityPercentDone: boolean = false;
  currentGanttDiagramHistory: number = 0;
  showDeleteModal: boolean = false;
  isInvestigator: boolean = false;
  permissionValue: PermissionValue = PermissionValue.INICIO;
  permissionAccess: PermissionAccess | any = {};

  reporteAprobado: ReportEvaluationState = ReportEvaluationState.Aprobado;
  reporteNoAprobado: ReportEvaluationState = ReportEvaluationState.NoAprobado;

  constructor() {
    super();
    this.controller = "Porposal";
    this.model = new Porposal();
    this.Coins = [];
    this.counter = 0;
    this.words = "";
    Quill.register("modules/imageDrop", ImageDrop);
  }
  onCloseModal(row: any) {
    row.showExpectResult = false;
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }
  showExpectResultOnClic(row: any, index: number) {
    row.showExpectResult = true;
    this.$nextTick().then(() => {
      this.$forceUpdate();
    });
  }
  getPrincipalInvestigator() {
    let name;
    this.memberTypeService.GetPrincipalInvestigator().then((response) => {
      this.principalInvestigatorName = response;
    });
  }

  cancelarEdicionScheduleGantt() {
    this.isEditingActivityPercentDone = !this.isEditingActivityPercentDone;
    for (let i = 0; i < this.model.proposalScheduleGanttPhases.length; i++) {
      this.model.proposalScheduleGanttPhases[
        i
      ].percentDone = this.model.proposalScheduleGanttPhases[i].percentDoneUI;
      for (
        let j = 0;
        j <
        this.model.proposalScheduleGanttPhases[i]
          .proposalScheduleGanttActivities.length;
        j++
      ) {
        this.model.proposalScheduleGanttPhases[
          i
        ].proposalScheduleGanttActivities[
          j
        ].percentDone = this.model.proposalScheduleGanttPhases[
          i
        ].proposalScheduleGanttActivities[j].percentDoneUI;
      }
    }
    this.defaultOpenedDetails = [];
  }

  async deleteGanttHistoryRecord(
    gantt: ProposalHistoricPercentDoneScheduleGantt
  ) {
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Sí",
      cancelText: "No",
      message: "¿Está seguro de querer eliminar el registro seleccionado?",
      onConfirm: () => this.confirmDeleteGanttHistoryRecord(gantt),
    });
  }

  async confirmDeleteGanttHistoryRecord(model) {
    this.showDeleteModal = false;
    this.loading = true;
    let response = await this.proposalService.deleteHistoricPercentDone(model);
    this.loading = false;
    this.operationSuccess();
    this.getData();
  }

  @Watch("currentGanttDiagramHistory")
  onCurrentGanttDiagramHistory(value: number) {
    let lastGanttHistory = this.model.proposalHistoricPercentDoneScheduleGantts[
      value - 1
    ];
    for (let i = 0; i < this.model.proposalScheduleGanttPhases.length; i++) {
      const phase = lastGanttHistory.proposalHistoricPhasesPercentDone.find(
        (x) =>
          x.proposalScheduleGanttPhaseId ==
          this.model.proposalScheduleGanttPhases[i].id
      );
      if (phase) {
        this.model.proposalScheduleGanttPhases[i].percentDone =
          phase.percentDone;
        this.model.proposalScheduleGanttPhases[i].percentDoneUI =
          phase.percentDone;
      }
      for (
        let j = 0;
        j <
        this.model.proposalScheduleGanttPhases[i]
          .proposalScheduleGanttActivities.length;
        j++
      ) {
        const activity = phase.proposalHistoricActivitiesPercentDone.find(
          (x) =>
            x.proposalScheduleGanttActivityId ==
            this.model.proposalScheduleGanttPhases[i]
              .proposalScheduleGanttActivities[j].id
        );
        if (activity) {
          this.model.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDone =
            activity.percentDone;
          this.model.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDoneUI =
            activity.percentDone;
        }
      }
    }
  }

  onGanttDagramChange() {
    for (let i = 0; i < this.model.proposalScheduleGanttPhases.length; i++) {
      let totalActividades = 0;
      for (
        let j = 0;
        j <
        this.model.proposalScheduleGanttPhases[i]
          .proposalScheduleGanttActivities.length;
        j++
      ) {
        let percentDone = Number(
          this.model.proposalScheduleGanttPhases[i]
            .proposalScheduleGanttActivities[j].percentDone
        );
        totalActividades += percentDone;
      }
      this.model.proposalScheduleGanttPhases[i].percentDone = Math.floor(
        totalActividades /
          this.model.proposalScheduleGanttPhases[i]
            .proposalScheduleGanttActivities.length
      );
    }
  }

  setCurrentMemberEffortToPrint(data: any) {
    this.currentMemberEffortToPrint = data;
    setTimeout(() => window.print(), 100);
  }

  get totalEffortPercentage() {
    let totalHrs = 0;
    let totalPercentage = 0;
    this.currentMemberEffortToPrint.proposalMemberEfforts.forEach(
      (proposalMemberEffort) => (totalHrs += proposalMemberEffort.hour)
    );
    this.currentMemberEffortToPrint.proposalMemberEfforts.forEach(
      (proposalMemberEffort) =>
        (totalPercentage += proposalMemberEffort.effortPorcentage)
    );
    return totalHrs + " horas (" + totalPercentage + "%)";
  }

  async updateDirsbursement() {
    this.loading = true;

    if (this.requestDateFile && !this.requestDateFile.id) {
      let doc = await fileService.upload(this.requestDateFile as File);
      doc.refEntityKey = "Id";
      doc.refEntityName = "ProposalDisbursement";
      doc.refEntityValue = this.currentDirsbuserment.id as any;
      this.currentDirsbuserment.requestDateDocument = doc;
    }

    if (this.deliveryDateFile && !this.deliveryDateFile.id) {
      let doc2 = await fileService.upload(this.deliveryDateFile as File);
      doc2.refEntityKey = "Id";
      doc2.refEntityName = "ProposalDisbursement";
      doc2.refEntityValue = this.currentDirsbuserment.id as any;
      this.currentDirsbuserment.deliveryDateDocument = doc2;
    }

    this.proposalService
      .updateDirsbursement(
        this.currentDirsbuserment.id,
        this.currentDirsbuserment
      )
      .then((response) => {
        this.proposalService
          .getDirsbursementByProposal(this.currentDirsbuserment.porposalId)
          .then((data) => {
            this.disbursementsTableConfig.data = data;
          });
        this.operationSuccess();
        this.showChangeStatus = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then((response) => {
      if (response) {
        this.budgetExpenses = response;
      }
    });
  }

  verDocumento(row: ProposalDocument) {
    return fileService.download(row.documentId);
  }
  async sendReportToIES(data: ProposalUserReport) {
    data.state = ProposalState.EnviadoCI;
    data.reason = null;
    this.isLoading = true;
    await this.proposalService.updateProposalUserReport(data.id, data);
    this.isLoading = false;

    if (data.isLastResport && data.state == ProposalState.EnviadoCI) {
      this.$emit("hideFondocytWarning", true);
    }
    this.operationSuccess("Se ha enviado su informe de manera exitosa");
    this.tableConfig.reload();
  }

  eliminarReport(data: any) {
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Sí",
      cancelText: "No",
      message: "Seguro de querer eliminar el informe seleccionado?",
      onConfirm: () => this.delete(data),
    });
  }

  async delete(data) {
    this.loading = true;
    data.deleted = true;
    data.document.deleted = true;
    this.proposalService
      .updateProposalUserReport(data.id, data)
      .then(() => {
        this.operationSuccess("Se ha eliminado su informe de manera exitosa");
        this.tableConfig.reload();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async updateActivitiesPercentDone() {
    this.loading = true;
    await this.proposalService.addHistoricPercentDone(this.model);
    this.operationSuccess();
    this.loading = false;
    this.getData();
    this.isEditingActivityPercentDone = !this.isEditingActivityPercentDone;
    this.defaultOpenedDetails = [];
  }

  get userCanAttachReport() {
    return this.model.porposalMembers.some((x) => x.userId == this.user.id)
      ? true
      : false;
  }

  validateLength(name: string) {
    if (name.length > 23) return name.substring(0, 23) + "...";
    else return name;
  }

  async verRequestDateDocument(data: any = null) {
    if (data.requestDateDocument.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        data.requestDateDocument.id,
        data.requestDateDocument.originalName
      );
    else await fileService.download(data.requestDateDocument.id);
  }

  async verDeliveryDateDocument(data: any = null) {
    if (data.deliveryDateDocument.contentType == "application/octet-stream")
      await fileService.downloadOctetFile(
        data.deliveryDateDocument.id,
        data.deliveryDateDocument.originalName
      );
    else await fileService.download(data.deliveryDateDocument.id);
  }

  async verDocument(data: any = null) {
    if (data.isLastResport) {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
      //
      if (data.projectEndDocument.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.projectEndDocument.id,
          data.projectEndDocument.originalName
        );
      else await fileService.download(data.projectEndDocument.id);
    } else {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
    }
  }

  editarReport(data: any) {
    this.$emit("userReportSelected", data);
  }

  @Watch("updateReports")
  onUpdateReportsChange(value: number) {
    if (value > 0) {
      this.tableConfig.reload();
    }
  }

  setCurrentDisbursment(data: ProposalDisbursement) {
    data.requestDate =
      data.requestDate != null ? new Date(data.requestDate) : new Date();
    data.deliveryDate =
      data.deliveryDate != null ? new Date(data.deliveryDate) : new Date();
    this.deliveryDateFile = data.deliveryDateDocument
      ? data.deliveryDateDocument
      : null;
    this.requestDateFile = data.requestDateDocument
      ? data.requestDateDocument
      : null;
    this.currentDirsbuserment = data;
    this.showChangeStatus = true;
  }

  @Watch("selectTabItem")
  onSelectTabItemChange(value: number) {
    if (value && value > 0) {
      this.activeTab = value;
    }
  }

  @Watch("activeTab")
  onActiveTabChange(value: number) {
    this.$emit("selectedTabChange", value);
  }

  @Watch("movimientos")
  onMovimientosChange(value: []) {
    if (value && value.length > 0) {
      this.model.proposalMovements = value;
    }
  }

  devolverPropuesta() {
    if (this.motivoDevolucion) {
      let model = {
        id: parseInt(this.$route.params.id),
        motivo: this.motivoDevolucion,
      };
      this.proposalService.devolverPropuesta(model).then((response) => {
        if (response) {
        }
      });
    }
  }
  onSelectDoc(selected: any) {
    if (this.model.proposalDocuments) {
      if (
        selected.documentId &&
        this.model.proposalDocuments.some(
          (y) => y.documentId === selected.documentId
        )
      ) {
        let index = this.model.proposalDocuments.findIndex(
          (y) => y.documentId === selected.documentId
        );
        this.model.proposalDocuments[index].deleted = false;
      } else if (
        this.model.proposalDocuments.some(
          (y) =>
            y.document && y.document.contentTypeId === selected.contentTypeId
        )
      ) {
        let index = this.model.proposalDocuments.findIndex(
          (y) =>
            y.document && y.document.contentTypeId === selected.contentTypeId
        );
        let doc = this.model.proposalDocuments[index];
        doc.documentId = selected.documentId;
        doc.document = selected.document || selected;
        this.model.proposalDocuments.splice(index, 1, doc);
      } else {
        let doc = new ProposalDocument();
        doc.documentId = selected.documentId;
        doc.document = selected.document;
        this.model.proposalDocuments.push(doc);
      }
    }
  }
  cleanObj(sendObject: Porposal) {
    sendObject.porposalBudgetItems = sendObject.porposalBudgetItems.map((x) => {
      x.budgetItem = null;
      return x;
    });

    sendObject.porposalMembers = sendObject.porposalMembers.map((x) => {
      x.user = null;
      return x;
    });

    sendObject.proporsalUsersEvaluators = sendObject.proporsalUsersEvaluators.map(
      (x) => {
        x.user = null;
        return x;
      }
    );

    sendObject.porposalUsersReports = sendObject.porposalUsersReports.map(
      (x) => {
        x.user = null;
        return x;
      }
    );

    sendObject.coin = null;
    sendObject.researchCenter = null;
    sendObject.area = null;
    sendObject.fieldArea = null;
    sendObject.researchLine = null;
  }
  protected async edit() {
    try {
      this.loading = true;

      var sendObject = Utils.mapToObject(
        this.model,
        new Porposal()
      ) as Porposal;
      this.cleanObj(sendObject);

      sendObject.isEditingBudgetFC = true;
      var result = await this.repository
        .update(this.id, sendObject)
        .finally(() => {
          this.getData();
        });

      this.loading = false;
      this.budgetEditMode = false;
      this.$emit("edit", result);
    } catch (error) {
      var errors: any[] = [];
      if (Object.prototype.toString.call(error.data) === "[object String]") {
        errors.push(error.data);
      } else if (error.data && error.data.length > 0) {
        var errorMessages = error.data as any[];
        errorMessages.forEach((x) => errors.push(x.errorMessage));
      } else {
        errors.push(error);
      }
      console.log(errors);
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  onModalClose() {
    this.currentDirsbuserment = new ProposalDisbursement();
    this.requestDateFile = null;
    this.deliveryDateFile = null;
  }

  protected async validate(
    ignoreWarnings: boolean = false,
    showBudgetReport: any = false
  ) {
    try {
      if (
        !ignoreWarnings &&
        (!this.validate20PercentInstitutionalAport ||
          this.validateBudgetItemIncludeInAnualRuleOfPayOfFondocyt ||
          this.validateBudgetSubItemDistribution ||
          this.validateBudgetItemRuleForPercentageLimitBasedInSubTotal)
      ) {
        this.showWarning = true;
      } else {
        this.showWarning = false;
        await this.edit();

        this.operationSuccess();
      }
    } catch (errors) {}
  }
  get validate20PercentInstitutionalAport() {
    if (!this.model.porposalBudgetItems.filter((x) => !x.deleted).length) {
      return true;
    }
    return this.totalBudgetInstitutionalAport >= (this.totalBudget * 20) / 100;
  }
  get validateBudgetSubItemDistribution() {
    if (!this.model.porposalBudgetItems.length) {
      return "";
    }
    var budgetItemFiltered = this.model.porposalBudgetItems.filter(
      (x) => !x.deleted
    );
    for (let i = 0; i < budgetItemFiltered.length; i++) {
      const item = budgetItemFiltered[i];
      var subItemFiltered = item.porposalBudgetSubItems.filter(
        (x) => !x.deleted
      );
      for (let y = 0; y < subItemFiltered.length; y++) {
        const subitem = subItemFiltered[y];
        var amountDistribute = this.calculateProposalBudgetSubItem(
          subitem
        ).toFixed(2);
        var totalAmount = subitem.unitCost * subitem.month;

        var withoutDistribution = totalAmount - amountDistribute;

        if (withoutDistribution > 0) {
          return `En la sub-partida presupuestaria <b>${
            subitem.budgetSubItem
          }</b> la  cual forma parte de la partida <b>${
            item.budgetItem.name
          }</b>  faltan por distribuir entre instituciones el monto de  <b>${
            this.model.coin.currency
          } ${this.$options.filters.currency(withoutDistribution)}</b>.`;
        } else if (withoutDistribution < 0) {
          return `En la sub-partida presupuestaria <b>${
            subitem.budgetSubItem
          }</b> la  cual forma parte de la partida <b>${
            item.budgetItem.name
          }</b>  se ha distribuido entre instituciones un monto de extra de  <b>${
            this.model.coin.currency
          } ${this.$options.filters.currency(withoutDistribution * -1)}</b>.`;
        }
      }
    }
  }

  get validateBudgetItemIncludeInAnualRuleOfPayOfFondocyt() {
    if (!this.model.porposalBudgetItems.length) {
      return "";
    }
    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var amountYearTopFondocyt = 0;
      var amountYear = 0;
      var porposalBudgetItems = this.model.porposalBudgetItems.filter((x) =>
        x.budgetItem ? x.budgetItem.hasIncludeInAnualRuleOfPayOfFondocyt : false
      );
      var porposalBudgetItemsFiltered = porposalBudgetItems.filter(
        (x) => !x.deleted
      );
      for (let i = 0; i < porposalBudgetItemsFiltered.length; i++) {
        const budgetItem = porposalBudgetItemsFiltered[i];

        var porposalBudgetSubItemsFiltered = budgetItem.porposalBudgetSubItems;

        for (let j = 0; j < porposalBudgetSubItemsFiltered.length; j++) {
          const subItem = porposalBudgetSubItemsFiltered[j];
          var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
            (x: PorposalBudgetSubItemInstitutionDetail) =>
              x.yearNumber == year && !x.deleted
          );

          for (let y = 0; y < subBudgetInstitutions.length; y++) {
            const subBudgetInstitution = subBudgetInstitutions[y];
            var amount = subBudgetInstitution.amount as any;
            if (subBudgetInstitution.isFondocyt) {
              amountYearTopFondocyt += amount;
            }
            amountYear += amount;
          }
        }
      }
      if (amountYearTopFondocyt > (amountYear * 10) / 100) {
        var porcentaje = ((amountYearTopFondocyt * 100) / amountYear).toFixed(
          2
        );
        return `En el año <b>${year}</b> la suma de las partidas marcadas como <b>\"Incluidas para reglas\" </b> es mayor al 10% del tope anual de FONDOCYT. Actualmente FONDOCYT en su prespuesto esta cubriendo un  <b>${porcentaje}% </b> del año  <b>${year} </b>.`;
      }
    }
    return "";
  }

  get validateBudgetItemRuleForPercentageLimitBasedInSubTotal() {
    if (!this.model.porposalBudgetItems.length) {
      return "";
    }

    var subTotal = 0;
    var porposalBudgetItems = this.model.porposalBudgetItems.filter(
      (x) =>
        (x.budgetItem
          ? !x.budgetItem.hasRuleForPercentageLimitBasedInSubTotal
          : false) && !x.deleted
    );

    for (let i = 0; i < porposalBudgetItems.length; i++) {
      const budgetItem = porposalBudgetItems[i];
      var subItemsFiltered = budgetItem.porposalBudgetSubItems.filter(
        (x) => !x.deleted
      );
      for (let j = 0; j < subItemsFiltered.length; j++) {
        const subItem = subItemsFiltered[j];
        var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
          (x) => !x.deleted
        );
        for (let y = 0; y < subBudgetInstitutions.length; y++) {
          const subBudgetInstitution = subBudgetInstitutions[y];
          var amount = subBudgetInstitution.amount as any;
          subTotal += amount;
        }
      }
    }

    var porposalBudgetItemsRuleForPercentage = this.model.porposalBudgetItems.filter(
      (x) =>
        (x.budgetItem
          ? x.budgetItem.hasRuleForPercentageLimitBasedInSubTotal
          : false) && !x.deleted
    );

    for (let i = 0; i < porposalBudgetItemsRuleForPercentage.length; i++) {
      var total = 0;

      const budgetItem = porposalBudgetItemsRuleForPercentage[i];
      var subItemsFiltered = budgetItem.porposalBudgetSubItems.filter(
        (x) => !x.deleted
      );
      for (let j = 0; j < subItemsFiltered.length; j++) {
        const subItem = subItemsFiltered[j];
        var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
          (x) => !x.deleted
        );
        for (let y = 0; y < subBudgetInstitutions.length; y++) {
          const subBudgetInstitution = subBudgetInstitutions[y];
          var amount = subBudgetInstitution.amount as any;
          total += amount;
        }
      }
      if (
        total >
        (subTotal * budgetItem.budgetItem.percentageLimitBasedInSubTotal) / 100
      ) {
        var porcentaje = ((total * 100) / subTotal).toFixed(2);

        return `La partida presupuestaria <b>${budgetItem.budgetItem.name}</b> sobrepasa su limite de <b>${budgetItem.budgetItem.percentageLimitBasedInSubTotal}%</b> basado en el subtotal actualmente tiene un porcentaje de <b>${porcentaje}%</b>.`;
      }
    }

    return "";
  }

  updateGantt() {
    this.isEditingActivityPercentDone = !this.isEditingActivityPercentDone;
    this.model.proposalScheduleGanttPhases.forEach((phase) => {
      this.defaultOpenedDetails.push(phase.taskId);
    });
  }

  sendProporsal() {
    let model = {
      userId: this.user.id,
      sendMail: false,
    };
    new BaseHttpClient("Porposal")
      .putAsync<any>("send", this.model.id, model)
      .then((result: any) => {
        this.$router.push(`/inicio`);
      })
      .catch((err: any) => console.log(err));
  }

  configureFrontEndTable() {
    this.disbursementsTableConfig.loadOnMount = false;
    let amount = new BTableColumn("amount", "table.amount", true);
    let disbursementDate = new BTableColumn(
      "disbursementDate",
      "table.disbursementDate",
      true
    );
    let requestDate = new BTableColumn(
      "requestDate",
      "table.requestBypassDate",
      true
    );
    let deliveryDate = new BTableColumn(
      "deliveryDate",
      "table.deliveryDate",
      true
    );
    disbursementDate.customTemplate = true;
    requestDate.customTemplate = true;
    deliveryDate.customTemplate = true;

    amount.customTemplate = true;
    this.disbursementsTableConfig.insertColumns(
      amount,
      disbursementDate,
      requestDate,
      deliveryDate
    );

    if (this.isInvestigator) {
      this.disbursementsTableConfig.actions.customTemplate = true;
      this.disbursementsTableConfig.enableDefaultColumns = false;
    } else {
      this.disbursementsTableConfig.activeActions = false;
    }
  }

  get lastProposalHistoricPercentDoneScheduleGanttPercentDone() {
    if (
      this.model &&
      this.model.proposalHistoricPercentDoneScheduleGantts &&
      this.model.proposalHistoricPercentDoneScheduleGantts.length > 0
    )
      return this.model.proposalHistoricPercentDoneScheduleGantts[
        this.model.proposalHistoricPercentDoneScheduleGantts.length - 1
      ].percentDone;
    else return 0;
  }

  protected async getData() {
    try {
      this.loading = true;
      let pId = this.id ? this.id : this.pId;
      let response = await this.repository.byId(pId, this.include);
      this.files = response.proposalDocuments.filter(
        (x) => x.document !== null
      );
      this.selected = this.files[0];
      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);

      this.model = response;
      // AnaliticalMatrix
      if (this.isEvaluationView) {
      }
      //
      let lastGanttHistory = this.model
        .proposalHistoricPercentDoneScheduleGantts[
        this.model.proposalHistoricPercentDoneScheduleGantts.length - 1
      ];

      for (let i = 0; i < this.model.proposalScheduleGanttPhases.length; i++) {
        const phase = lastGanttHistory.proposalHistoricPhasesPercentDone.find(
          (x) =>
            x.proposalScheduleGanttPhaseId ==
            this.model.proposalScheduleGanttPhases[i].id
        );
        if (phase) {
          this.model.proposalScheduleGanttPhases[i].percentDone =
            phase.percentDone;
          this.model.proposalScheduleGanttPhases[i].percentDoneUI =
            phase.percentDone;
        }
        for (
          let j = 0;
          j <
          this.model.proposalScheduleGanttPhases[i]
            .proposalScheduleGanttActivities.length;
          j++
        ) {
          const activity = phase.proposalHistoricActivitiesPercentDone.find(
            (x) =>
              x.proposalScheduleGanttActivityId ==
              this.model.proposalScheduleGanttPhases[i]
                .proposalScheduleGanttActivities[j].id
          );
          if (activity) {
            this.model.proposalScheduleGanttPhases[
              i
            ].proposalScheduleGanttActivities[j].percentDone =
              activity.percentDone;
            this.model.proposalScheduleGanttPhases[
              i
            ].proposalScheduleGanttActivities[j].percentDoneUI =
              activity.percentDone;
          }
        }
      }
      console.log(this.model);
      this.currentGanttDiagramHistory = this.model.proposalHistoricPercentDoneScheduleGantts.length;
      this.annoucementId = this.model.annoucementId as number;
      this.modelInit = this.map<Porposal>(this.model);
      this.disbursementsTableConfig.data = this.model.proposalDisbursements;
      this.$emit("updateModel", this.model);

      if (this.isEvaluationView) {
        this.updateMatrixModel();
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
      this.$emit("showModalEvaluadores", true);
    }
  }

  @Watch("currentUserAnalyticalMatrixEvaluations")
  onMatrixChange() {
    if (this.isEvaluationView) {
      this.updateMatrixModel();
    }
  }

  updateMatrixModel() {
    if (this.currentUserAnalyticalMatrixEvaluations.length === 0) {
      this.model.especificObjectives.forEach((objetive) => {
        let analyticalMatrixEvaluation = new AnalyticalMatrixEvaluation();
        analyticalMatrixEvaluation.especificObjectiveId = objetive.id;
        analyticalMatrixEvaluation.porposalUserReportEvaluationId = this.currentReportEvaluationId;
        analyticalMatrixEvaluation.radioButtonGuidUI = Utils.newGUID();
        objetive.evaluationModelUI = analyticalMatrixEvaluation;
      });
    } else {
      this.model.especificObjectives.forEach((objetive) => {
        objetive.evaluationModelUI = this.currentUserAnalyticalMatrixEvaluations.find(
          (x) => x.especificObjectiveId == objetive.id
        );
        objetive.evaluationModelUI.radioButtonGuidUI = Utils.newGUID();
      });
    }
    this.$emit(
      "objetivosAlcanzados",
      this.model.especificObjectives.filter((x) => x.wasAchieved)
    );
  }

  guardarEvaluacion() {
    this.updatedUserAnalyticalMatrixEvaluations = [];
    this.model.especificObjectives.forEach((objetive) => {
      this.updatedUserAnalyticalMatrixEvaluations.push(
        objetive.evaluationModelUI
      );
    });
    this.$emit(
      "onUpdatedUserAnalyticalMatrixEvaluations",
      this.updatedUserAnalyticalMatrixEvaluations
    );
  }

  get isProyectCompleted() {
    if (this.model && this.model.proposalHistoricPercentDoneScheduleGantts) {
      return this.model.proposalHistoricPercentDoneScheduleGantts.some(
        (x) => x.percentDone == 100
      );
    } else return false;
  }

  get totalInMounth() {
    let startDate = this.model.startDate as any;
    let endDate = this.model.endDate as any;
    this.model.periodMonth = Math.ceil(
      moment(endDate).diff(startDate, "month", true)
    );
    var years = Math.ceil(this.model.periodMonth / 12);
    this.years = [];
    for (let i = 1; i <= years; i++) {
      this.years.push(i);
    }
    return this.model.periodMonth;
  }

  get user() {
    return this.$store.state.user;
  }

  redirectToApproval(data: any) {
    window.open(
      `${process.env.VUE_APP_BASE_URL}EvaluateLastReport/${data.id}`,
      "blank"
    );
  }

  async created() {
    this.getPrincipalInvestigator();
    this.permissionValue = PermissionValue.PROPUESTASFONDOCYT;
    this.permissionAccess = this.userService.getPermissionAccessLevel(
      this.permissionValue
    );
    let pId = this.id ? this.id : this.pId;
    let proposalId = Number(pId);
    this.tableConfig.controller = `PorposalUserReport`;
    this.tableConfig.whereParams = `ProposalId eq ${proposalId}`;
    this.isInvestigator = await this.proposalService.validaIsInvestigator(
      proposalId,
      this.user.id
    );
    this.configureFrontEndTable();
    this.tableConfig.rowClass = (row: ProposalUserReport, index: number) =>
      row.projectEndDocument && "is-primary-mescyt";
    this.formatColumns();
    this.getBudgetExpenses();
  }

  async updateAnalitica() {
    this.loading = true;
    let especificObjectiveWrapper = {
      specificObjetives: this.model.especificObjectives,
    };
    let data = await this.proposalService.updateMatrizAnalitica(
      this.model.id,
      especificObjectiveWrapper
    );
    this.loading = false;
    this.operationSuccess();
  }

  @Watch("model")
  onModelChange(value: number) {
    if (this.model) {
      this.$emit("totalAprovedFondocyt", this.model.fondocytContribution);
      this.$emit("totalDesembolsado", this.model.totalDisbursedToDate);
      this.$emit("totalGastadoHastaElMomento", this.model.totalSpentToDate);
      this.$emit(
        "totalDisponibleInvestigador",
        this.model.totalDisbursedToDate - this.model.totalSpentToDate
      );
      this.$emit("totalDisponibleFondocyt", this.model.pendingDisbursement);
    }
  }

  totalBudgetFondocyt: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  totalBudget: number = 0;
  budgetSubItemCurrent = new PorposalBudgetSubItem();
  showAddSubPartida = false;

  get institutionBudgetByYear() {
    var institutionBudgetByYear = [];
    if (!this.model.porposalBudgetItems.filter((x) => !x.deleted).length) {
      return true;
    }
    this.totalBudgetFondocyt = 0;
    this.totalBudgetInstitutionalAport = 0;
    this.totalBudget = 0;
    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var resume = {
        year: 0,
        FONDOCYT: 0,
        institutionalAport: 0,
        othersInstitutions: 0,
      };
      var porposalBudgetItemsFiltered = this.model.porposalBudgetItems.filter(
        (x) => !x.deleted
      );
      for (let i = 0; i < porposalBudgetItemsFiltered.length; i++) {
        const budgetItem = porposalBudgetItemsFiltered[i];
        var porposalBudgetSubItemsFiltered = budgetItem.porposalBudgetSubItems;

        for (let j = 0; j < porposalBudgetSubItemsFiltered.length; j++) {
          const subItem = porposalBudgetSubItemsFiltered[j];
          var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
            (x: PorposalBudgetSubItemInstitutionDetail) =>
              x.yearNumber == year && !x.deleted
          );
          resume.year = year;

          for (let y = 0; y < subBudgetInstitutions.length; y++) {
            const subBudgetInstitution = subBudgetInstitutions[y];
            var amount = subBudgetInstitution.amount as any;
            if (subBudgetInstitution.isFondocyt) {
              resume.FONDOCYT += amount;
            } else if (subBudgetInstitution.researchCenterId) {
              resume.institutionalAport += amount;
            } else {
              resume.othersInstitutions += amount;
            }
          }
        }
      }
      institutionBudgetByYear.push(resume);
      this.totalBudgetFondocyt += resume.FONDOCYT;
      this.totalBudgetInstitutionalAport += resume.institutionalAport;
      this.totalBudget +=
        resume.FONDOCYT + resume.institutionalAport + resume.othersInstitutions;
    }
    return institutionBudgetByYear;
  }
  public getcenterByInvestigatorId() {
    if (this.userService) {
      this.userService
        .researchCenterByInvestigator(this.user.id)
        .then((center) => {
          this.researchCenters = center;
        });
    }
  }

  get totalProyecto() {
    var total = {
      FONDOCYT: 0,
      TotalGeneral: 0,
      ContraPartida: 0,
    };
    for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
      const item = this.model.porposalBudgetItems[i];
      for (let y = 0; y < item.porposalBudgetSubItems.length; y++) {
        const subItem = item.porposalBudgetSubItems[y];
        for (
          let z = 0;
          z < subItem.porposalBudgetSubItemInstitutionDetails.length;
          z++
        ) {
          const detail = subItem.porposalBudgetSubItemInstitutionDetails[z];
          total.TotalGeneral += detail.amount;
          if (detail.isFondocyt) {
            total.FONDOCYT += detail.amount;
          } else {
            total.ContraPartida += detail.amount;
          }
        }
      }
    }

    return total;
  }

  calculateProposalBudgetSubItemByInstitution(
    porposalBudgetSubItem: PorposalBudgetSubItem
  ) {
    if (porposalBudgetSubItem.currentInstitution == 0) {
      var filteredDetails = porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.filter(
        (x) => x.isFondocyt && !x.deleted
      );
      return filteredDetails.reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
    } else {
      var filteredDetails = porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.filter(
        (x) =>
          (x.researchCenterId == porposalBudgetSubItem.currentInstitution ||
            x.institutionName == porposalBudgetSubItem.currentInstitution) &&
          !x.deleted
      );
      return filteredDetails.reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
    }
  }

  calculateProposalBudgetSubItem(porposalBudgetSubItem: PorposalBudgetSubItem) {
    return porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails
      .filter((x) => !x.deleted)
      .reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
  }
  calculateProposalBudgetItemByYear(porposalBudgetItem: PorposalBudgetItem) {
    var budgets = porposalBudgetItem.porposalBudgetItemInstitutions
      .filter((x) => !x.deleted)
      .filter((x: any) => x.yearNumber == porposalBudgetItem.currentYear);
    return budgets.reduce((a: any, b: any) => {
      var amount = b.amount ? parseFloat(b.amount as any) : 0;
      return a + amount;
    }, 0);
  }

  showModalBudgetSubItem(porposalBudgetItem: PorposalBudgetItem) {
    this.showAddSubPartida = true;
    this.budgetSubItemCurrent.porposalBudgetItem = porposalBudgetItem;
    this.budgetSubItemCurrent.budgetItemId = porposalBudgetItem.budgetItemId;
  }
  addBudgetSubItem() {
    if (this.budgetSubItemCurrent.budgetSubItem) {
      var porposalBudgetSubItem = Utils.mapToObject(
        this.budgetSubItemCurrent,
        new PorposalBudgetSubItem()
      ) as PorposalBudgetSubItem;

      var defaultPeriod = YearPeriod.ThreeMonth;
      var quantityMonth = 12;
      var quantityPeriodInYear = quantityMonth / defaultPeriod;

      for (let y = 0; y < this.years.length; y++) {
        const year = this.years[y];

        var startPeriod = 1;
        var endPeriod = quantityPeriodInYear;
        if (y == 0) {
          if (this.model.startDate) {
            var startPeriod = Math.ceil(
              (this.model.startDate.getMonth() + 1) / defaultPeriod
            );
          }
        } else if (y == this.years.length - 1) {
          if (this.model.endDate) {
            endPeriod = Math.ceil(
              (this.model.endDate.getMonth() + 1) / defaultPeriod
            );
          }
        }

        for (let i = startPeriod; i <= endPeriod; i++) {
          let detail = new PorposalBudgetSubItemInstitutionDetail();
          detail.yearNumber = year;
          detail.periodNumber = i;
          detail.isFondocyt = true;
          porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
            detail
          );
        }
        let detail2 = new PorposalBudgetSubItemInstitutionDetail();
        detail2.yearNumber = year;
        detail2.researchCenterId = this.model.researchCenterId;
        porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
          detail2
        );
      }

      this.budgetSubItemCurrent.porposalBudgetItem.porposalBudgetSubItems.push(
        porposalBudgetSubItem
      );

      this.budgetSubItemCurrent.init();
      this.showAddSubPartida = false;
    } else {
      this.operationFailed("Debe escribir la sub-partida");
    }
  }

  onCancelSubPartida() {
    this.showAddSubPartida = false;
  }

  removePorposalBudgetSubItem(
    porposalBudgetSubItem: PorposalBudgetSubItem,
    porposalBudgetItem: PorposalBudgetItem
  ) {
    if (porposalBudgetSubItem.id) {
      porposalBudgetSubItem.deleted = true;
    } else {
      porposalBudgetItem.porposalBudgetSubItems = porposalBudgetItem.porposalBudgetSubItems.filter(
        (x: any) => x != porposalBudgetSubItem
      );
    }
  }

  showBudgetItem(budgetExpenseId: number) {
    this.showAddPartida = true;
    this.budgetItemCurrent.budgetExpenseId = budgetExpenseId;
  }
  addPartida() {
    if (this.budgetItemCurrent.budgetItem.id) {
      var newPartida = Utils.mapToObject(
        this.budgetItemCurrent,
        new PorposalBudgetItem()
      ) as PorposalBudgetItem;
      this.model.porposalBudgetItems.push(newPartida);
      this.budgetItemCurrent.init();
      this.showAddPartida = false;
    } else {
      this.operationFailed("Debe seleccionar una partida");
    }
  }
  deletePartida(item: PorposalBudgetItem) {
    if (item.id) {
      item.deleted = true;
    } else {
      this.model.porposalBudgetItems = this.model.porposalBudgetItems.filter(
        (budgetItem) => budgetItem != item
      );
    }
  }

  onBugetItem(item: BudgetItem) {
    this.budgetItemCurrent.budgetItem = item;
  }
  onRemoveBugetItem() {
    this.budgetItemCurrent.budgetItem = new BudgetItem();
  }

  formatColumns() {
    let docTitle = new BTableColumn("docTitle", "table.title", true);
    let description = new BTableColumn(
      "description",
      "table.description",
      true
    );
    let stateDescription = new BTableColumn(
      "stateDescription",
      "table.estado",
      true
    );
    let reason = new BTableColumn("reason", "table.reason", true);

    docTitle.customTemplate = true;
    description.customTemplate = true;
    stateDescription.customTemplate = true;
    reason.customTemplate = true;
    docTitle.width = "250";
    this.tableConfig.insertColumns(
      docTitle,
      description,
      stateDescription,
      reason
    );

    //this.tableConfig.activeActions = this.userCanAttachReport;
    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }

  downloadBudget() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      "Report/DownloadFilePdfPresupuesto?proporsalId=" +
      this.model.id;
    Utils.downloadURI(url, "Presupuesto.xls");
  }

  downloadCashFlow() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      "Report/DownloadFilePdfCashFlow?proporsalId=" +
      this.model.id;
    Utils.downloadURI(url, "FlujoDeCaja.xls");
  }
}
